<!--首页-招投标服务-退还保证金-->
<template>
  <!--  保证金展示内容 开始  -->
  <div class="tender_label_table">
    <!--   筛选条件栏位 开始   -->
    <div class="tender_label_box" v-if="isShowBatch">
      <div class="tender_label">批次：</div>
      <div v-for='(item,i) in batchCategoryList'
           :class="batchClassifyCode==item.code ? 'tender_value_selected' : 'tender_value'"><a
        @click="changeBatchCategory(item.code)">{{ item.name }}</a></div>
    </div>

    <div class="tender_label_box" style="line-height: 50px; text-align: center">
      <div class="tender_label">企业名称：</div>
      <div class="tender_value" style="padding-left:16px;">
        <a-input type="text" v-model="queryEnterpriseName" style="width: 570px;" @change="changeEnterpriseName()"
                 placeholder="请输入企业名称模糊查询">
        </a-input>
      </div>
    </div>
    <!--   筛选条件栏位 结束   -->

    <div class="noticeDiv">
      <a-table
        :columns="columns"
        :data-source="dataSource"
        :pagination="ipagination"
        @change="handleTableChange"
      />
    </div>
  </div>
  <!--  保证金展示内容 结束  -->
</template>

<script>
import {queryDepositReleasedInfo} from "@api/portal";

export default {
  name: "TmDepositReleasedDetailModule",
  props: [
    'sectionId'
  ],
  created() {
    // TODO 查询标段的保证金详情
    this.queryDepositReleasedInfo()
  },
  data() {
    return {
      dataSource: [],
      columns: [
        {
          title: '序号',
          dataIndex: 'id',
          key: 'id',
          customRender: function (t, r, index) {
            return parseInt(index) + 1
          }
        },
        {
          title: '企业名称',
          dataIndex: 'enterpriseName',
          key: 'enterpriseName',
        },
        {
          title: '标段名称',
          dataIndex: 'sectionName',
          key: 'sectionName',
        },
        {
          title: '退款金额(元)',
          dataIndex: 'refundAmount',
          key: 'refundAmount',
        },
        {
          title: '退款时间',
          dataIndex: 'refundTime',
          key: 'refundTime',
        },
      ],
      /* 分页参数 */
      ipagination: {
        current: 1,
        pageSize: 10,
        pageSizeOptions: ['10', '20', '30'],
        showTotal: (total, range) => {
          return range[0] + '-' + range[1] + ' 共' + total + '条'
        },
        showQuickJumper: true,
        showSizeChanger: true,
        total: 0
      },
      batchClassifyCode: 1,
      batchCategoryList: [],
      queryEnterpriseName: "",
      isShowBatch: false,
    }
  },
  methods: {
    changeEnterpriseName() {
      this.queryDepositReleasedInfo()
    },
    handleTableChange(pagination, filters, sorter) {
      //分页、排序、筛选变化时触发
      //TODO 筛选
      if (Object.keys(sorter).length > 0) {
        this.isorter.column = sorter.field;
        this.isorter.order = "ascend" == sorter.order ? "asc" : "desc"
      }
      this.ipagination = pagination;
      this.queryDepositReleasedInfo();
    },
    changeBatchCategory(category) {
      this.batchCategory = category;
      this.queryDepositReleasedInfo();
    },
    queryDepositReleasedInfo() {
      let params = {
        "sectionId": this.sectionId,
        "batchClassifyCode": this.batchClassifyCode,
        "enterpriseName": this.queryEnterpriseName,
        "pageNo": this.ipagination.current,
        "pageSize": this.ipagination.pageSize,
      }
      queryDepositReleasedInfo(params).then(res => {
        console.log(JSON.stringify(res))
        if (res.success) {
          this.isShowBatch = true;
        }
        this.dataSource = res.result.records
        this.ipagination.total = res.result.total
      });
    },

  }
}
</script>

<style scoped lang="less">
@import '~@assets/less/PortalSearchBar.less';
</style>